import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import { AnalyticsService } from "../../services/analytics.service";
import "./form-item-insurance-personal.component.scss";
var FormItemInsurancePersonal = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemInsurancePersonal, _super);
    function FormItemInsurancePersonal(element) {
        return _super.call(this, element) || this;
    }
    FormItemInsurancePersonal.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.selectType = this.element.querySelector("select[name=query-type]");
        this.selectProductContainer = this.element.querySelector("div.form-item__insurance--personal--hidden__product-select");
        this.selectProduct = this.element.querySelector("select[name=product-type]");
        this.hiddenProduct = this.element.querySelector("input[name=product-type-hidden]");
        this.formFieldsContainer = this.element.querySelector("div.form__fields--container");
        this.submitBtn = Array.from(this.element.querySelectorAll(".js-apply-now__button"));
        this.recipientInput = this.element.querySelector("input[name=recipient]");
        this.emailInput = this.element.querySelector("input[name=email]");
        this.subjectInput = this.element.querySelector("input[name=subject]");
    };
    FormItemInsurancePersonal.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.map(function (item) {
            return item.addEventListener("click", function (event) {
                var _button = event.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length == 0) {
                    _this.submitForm(_form);
                }
            });
        });
        if (this.selectType) {
            this.selectType.addEventListener("change", function (event) {
                return _this.queryType(event);
            });
        }
        if (typeof this.selectProduct != "undefined" &&
            this.selectProduct != null) {
            this.selectProduct.addEventListener("change", function (event) {
                return _this.productType(event);
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    FormItemInsurancePersonal.prototype.queryType = function (event) {
        var element = event.target;
        var value = element.value;
        var fieldContainer = this.form.querySelector("div.form__fields--container");
        var fieldClaimNumber = fieldContainer.querySelector("div.form__group--claim-number");
        if (fieldClaimNumber) {
            fieldContainer.removeChild(fieldClaimNumber);
        }
        this.form.setAttribute("id", "apply-now-submit_application_insurance");
        this.typeSelection = value;
        if (typeof this.selectProduct != "undefined" &&
            this.selectProduct != null) {
            this.selectProductContainer.classList.add("form-item__insurance--personal--hidden__product-select");
            this.selectProductContainer.classList.remove("form-item__insurance--personal--hidden__product-select");
        }
        if (typeof this.hiddenProduct != "undefined" &&
            this.hiddenProduct != null) {
            var hiddenInput = this.hiddenProduct;
            this.recipients(hiddenInput.value);
        }
        if (value == "policyUpdates") {
            this.createInput("Policy number", "policy-number", "Enter your policy number");
            this.form.setAttribute("id", "apply-now-submit_application_mail");
        }
        else if (value == "claimsQuery") {
            this.createInput("Policy/Claim number", "policy-claim-number", "Enter your policy or claim number");
            this.form.setAttribute("id", "apply-now-submit_application_mail");
        }
        else {
            this.form.setAttribute("id", "apply-now-submit_application_insurance");
        }
    };
    FormItemInsurancePersonal.prototype.createInput = function (label, name, placeholder, required, type) {
        if (placeholder === void 0) { placeholder = ""; }
        if (required === void 0) { required = false; }
        if (type === void 0) { type = ""; }
        var container = this.formFieldsContainer;
        var fieldBefore = container.querySelector("div.apply-now__note");
        var fieldContainer = document.createElement("div");
        fieldContainer.classList.add("form__group");
        fieldContainer.classList.add("form__group--claim-number");
        var fieldLabel = document.createElement("label");
        fieldLabel.classList.add("form__label");
        fieldLabel.innerHTML = label;
        var fieldInput = document.createElement("input");
        fieldInput.classList.add("form__input");
        if (required) {
            fieldInput.classList.add("form__input--required");
        }
        fieldInput.setAttribute("type", "text");
        fieldInput.setAttribute("name", name);
        fieldInput.setAttribute("placeholder", placeholder);
        fieldContainer.appendChild(fieldLabel);
        fieldContainer.appendChild(fieldInput);
        container.insertBefore(fieldContainer, fieldBefore);
    };
    FormItemInsurancePersonal.prototype.productType = function (event) {
        var element = event.target;
        var value = element.value;
        this.recipients(value);
    };
    FormItemInsurancePersonal.prototype.recipients = function (value) {
        if (this.typeSelection == "policyUpdates") {
            if (value == "348" || value == "354" || value == "355") {
                this.recipientInput.value =
                    "SBIB.Creditlife@standardbank.co.za";
                this.emailInput.value = "SBIB.Creditlife@standardbank.co.za";
            }
            else if (value == "349" ||
                value == "350" ||
                value == "352" ||
                value == "353") {
                this.recipientInput.value = "sbibservices@standardbank.co.za";
                this.emailInput.value = "sbibservices@standardbank.co.za";
            }
        }
        else if (this.typeSelection == "claimsQuery") {
            if (value == "348" ||
                value == "352" ||
                value == "354" ||
                value == "355") {
                this.recipientInput.value =
                    "creditlifeclaims@standardbank.co.za";
                this.emailInput.value = "creditlifeclaims@standardbank.co.za";
            }
            else if (value == "349") {
                this.recipientInput.value =
                    "FuneralClaimsDocuments@standardbank.co.za";
                this.emailInput.value =
                    "FuneralClaimsDocuments@standardbank.co.za";
            }
            else if (value == "350" || value == "353") {
                this.recipientInput.value = "stansureclient@standardbank.co.za";
                this.emailInput.value = "stansureclient@standardbank.co.za";
            }
        }
    };
    FormItemInsurancePersonal.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/services/SBIS_Handler_COZA.jsp";
        var config = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        var postData = "";
        var firstname = form.querySelector("input[name=first-name]");
        if (firstname) {
            postData += "first=" + firstname.value;
        }
        var lastname = form.querySelector("input[name=last-name]");
        if (lastname) {
            postData += "&last=" + lastname.value;
        }
        var contact = form.querySelector("input[name=phone-number]");
        if (contact) {
            postData += "&cell=" + contact.value;
        }
        var emailAddress = form.querySelector("input[name=email-address]");
        if (emailAddress) {
            postData += "&emailAddress=" + emailAddress.value;
        }
        var productTypeSelect = form.querySelector("select[name=product-type]");
        var productTypeHidden = form.querySelector("input[name=product-type-hidden]");
        if (productTypeSelect) {
            postData += "&product=" + productTypeSelect.value;
        }
        else {
            if (productTypeHidden) {
                postData += "&product=" + productTypeHidden.value;
            }
        }
        postData += "&source=" + this.formsService.isMobile();
        // service
        this.formsService
            .postForm(url, postData, config)
            .then(function (response) {
            // service ok
            if (response.data === "invalid") {
                analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                loader.classList.remove("active");
                fieldsContainer.classList.remove("hidden");
            }
            else {
                analyticsService.dtmFormComplete("complete", response.data, false, "", emailAddress.value, contact.value);
                loader.classList.remove("active");
                thankYou.classList.add("active");
            }
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            loader.classList.remove("active");
            fieldsContainer.classList.remove("hidden");
        });
    };
    return FormItemInsurancePersonal;
}(Base));
export { FormItemInsurancePersonal };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-insurance-personal/form-item-insurance-personal.component.ts
// module id = 927
// module chunks = 0